@if (isInitialized) {
  <oe-chart [showTotal]="showTotal" (setShowTotal)="setShowTotal($event)"
    [period]="service.historyPeriod" [title]="'EDGE.INDEX.WIDGETS.CHANNELTRESHOLD.TITLE'| translate">
    <totalChart [isOnlyChart]="true"></totalChart>
  </oe-chart>
}
